import React, { useEffect, useRef } from 'react';
import { Measure } from './Measure';
import Modal from '../../components/Modal';
import useProps from '../../../use-props';
import { Button, Checkbox, Space } from 'antd';

const title = {
    MeasureDistance: '测距',
    MeasureArea: '测面',
    MeasureHeight: '测高',
};

export default props => {
    const {
        type = 'MeasureDistance', // 测距 MeasureDistance | 测面 MeasureArea | 测高 MeasureHeight
        active,
        onClose,
        ...rest
    } = props;

    const { map } = useProps();
    const measure = useRef();

    const startDraw = () => {
        measure.current.destroy();
        const func = {
            MeasureDistance: 'measurePolyLine',
            MeasureArea: 'measurePolygon',
            MeasureHeight: 'measureHeight',
        };
        measure.current[func[type]]();
    };

    useEffect(() => {
        measure.current = new Measure(map);
        startDraw();
        return () => {
            measure.current.destroy();
        };
    }, [active]);

    return (
        <Modal title={title[type]} onClose={onClose} {...rest}>
            <Space>
                <Checkbox
                    onChange={e => {
                        measure.current.visibleLabelEntity(e.target.checked);
                    }}
                    defaultChecked={true}
                >
                    显示每段长度
                </Checkbox>
                <Checkbox
                    defaultChecked={true}
                    onChange={e => {
                        measure.current.clearLast = e.target.checked;
                    }}
                >
                    清除上次的测量结果
                </Checkbox>
            </Space>
        </Modal>
    );
};
